// htmx 4 request hook: attach the per-page nonce (FR-UI-07) and the
// session CSRF token (FR-LOGIN-08) to every htmx request.

import { CSRF_HEADER, csrfToken } from "./csrf";
import { sessionFetch } from "./session";

declare const htmx: {
  on: (event: string, handler: (evt: CustomEvent) => void) => void;
};

function pageNonce(): string | null {
  const script = document.querySelector<HTMLScriptElement>("script[nonce]");
  return script?.nonce ?? null;
}

export function installHtmxHooks(): void {
  htmx.on("htmx:config:request", (evt: CustomEvent) => {
    // htmx 4 hands over the request's context, whose headers are sent as
    // they stand once this event is handled; `evt.detail.headers` was
    // htmx 2's, and is never set.
    const ctx = evt.detail?.ctx as
      | {
          request?: { headers?: Record<string, string> };
          fetch?: typeof fetch;
        }
      | undefined;
    const headers = ctx?.request?.headers;
    if (!ctx || !headers) return;
    const nonce = pageNonce();
    if (nonce) headers["X-Specter-Page-Nonce"] = nonce;
    const csrf = csrfToken();
    if (csrf) headers[CSRF_HEADER] = csrf;
    // Refused as sent from a page of an earlier session, it goes once more
    // with the new session's token when the page is the same person's
    // (`session.ts`); htmx swaps whichever answer comes last.
    ctx.fetch = sessionFetch;
  });
}

installHtmxHooks();
